import {Component, NgZone, OnInit, ChangeDetectionStrategy, inject} from '@angular/core';
import { AuthTokenStore } from './services/auth-token/auth-token.store';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import {NavigationEnd, Router} from '@angular/router';
import {
  ApiService,
  ExclusionService,
  Events,
  PusherService,
  SpritessyncService,
  CountrycheckService,
  AppsflyerService, NetworkService
} from './services/services';
import { environment as ENV } from '../environments/environment' ;
import { ToastController, Platform, IonApp, IonRouterOutlet } from '@ionic/angular';
import {PushserviceService} from './services/services';
import { register } from 'swiper/element/bundle';
import { SplashScreen } from '@capacitor/splash-screen';
import { App } from '@capacitor/app';
import {AmplitudeService} from "./services/amplitude/amplitude.service";
import { RealityCheckService } from './services/reality-check/reality-check.service';
import {RealityCheckComponent} from "./components/reality-check/reality-check.component";
import {TokenService} from "./services/token/token.service";
import {LoadingOverlayComponent} from "./components/loading-overlay/loading-overlay.component";
import {PwaInstallService} from "./services/pwa/pwa-install.service";
import {PwaUpdateService} from "./services/pwa/pwa-update.service";
import {PwaCacheService} from "./services/pwa/pwa-cache.service";
import {AnnounceComponent} from "./components/announce/announce.component";
import {AppSettingsService} from "./services/app-settings/app-settings.service";
import {DeepLinkService} from "./services/deep-link/deep-link.service";

register();


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonApp, IonRouterOutlet, RealityCheckComponent, AnnounceComponent, LoadingOverlayComponent]
})
export class AppComponent implements OnInit {
  private readonly authTokenStore = inject(AuthTokenStore);

  private readonly whiteStatusTextRoutes = [
    '/',
    '/welcome',
    '/tabs/home',
    '/tabs/games',
  ];

  showInfoComponent = false;
  showInfoWindow = false;
  inforWindowTitle = 'User blocked';
  inforWindowDescription = '';
  inforWindowCloseText = 'OK'

  constructor(
    private router: Router,
    public excl: ExclusionService,
    public api: ApiService,
    public pusherServ: PusherService,
    public events: Events,
    public toastController: ToastController,
    public platform: Platform,
    private ngZone: NgZone,
    public sprSync: SpritessyncService,
    public pushServ: PushserviceService,
    public cCheck: CountrycheckService,
    public appsFlyerServ: AppsflyerService,
    private ampl: AmplitudeService,
    private realityCheckService: RealityCheckService,
    public networkServ: NetworkService,
    public tokenService: TokenService,
    private appSettings: AppSettingsService,
    private deepLinkService: DeepLinkService,
    // Both only matter on the web; this one has to exist early to catch the browser's install prompt.
    _pwaInstall: PwaInstallService,
    pwaUpdate: PwaUpdateService,
    pwaCache: PwaCacheService
  ) {
    pwaUpdate.start();
    pwaCache.start();

    this.safeArea();



    this.events.subscribe('http:forbidden', error => {
      this.router.navigate(['welcome']);
    });

    platform.ready().then(async () => {
      this.networkServ.initNetworkListener();

      this.configureStatusBar();
      this.cCheck.checkIfDeviceRooted();

      this.appsFlyerServ.initAppsFlyer();
      this.deepLinkService.init();



      if (localStorage.getItem('gameSounds') == null) {
        localStorage.setItem('gameSounds', 'true');
      }

      App.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
          this.appSettings.load();
          const userSessionToken = this.authTokenStore.getToken();

          if (userSessionToken) {
            this.pusherServ.initPusher();
            this.pusherServ.loadBalance(userSessionToken);
          }
        }
      });


    });
  }


  private async configureStatusBar() {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      await StatusBar.setOverlaysWebView({ overlay: true });
      await this.applyStatusBarStyleForUrl(this.router.url);

      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.applyStatusBarStyleForUrl(event.urlAfterRedirects);
        }
      });
    } catch {}
  }

  private async applyStatusBarStyleForUrl(url: string) {
    const path = url.split('?')[0].split('#')[0];
    const useWhiteStatusText = this.whiteStatusTextRoutes.some(route => (
      path === route || (route !== '/' && path.startsWith(`${route}/`))
    ));

    await StatusBar.setStyle({ style: useWhiteStatusText ? Style.Dark : Style.Light });
  }



  private async safeArea() {
    // SafeArea.getSafeAreaInsets().then((data) => {
    //   const { insets } = data;
    //   document.body.style.setProperty("--ion-safe-area-top", `${insets.top}px`);
    //   document.body.style.setProperty(
    //     "--ion-safe-area-right",
    //     `${insets.right}px`
    //   );
    //   document.body.style.setProperty(
    //     "--ion-safe-area-bottom",
    //     `${insets.bottom}px`
    //   );
    //   document.body.style.setProperty(
    //     "--ion-safe-area-left",
    //     `${insets.left}px`
    //   );
    // });
  }

  checkExclusion(checkRes) {
    this.inforWindowTitle = 'User blocked';
    this.inforWindowDescription = 'Your account has been restricted for ' + checkRes.data.length + ' from ' +checkRes.data.since + '. Please contact ' + ENV.supportEmail + ' for more information';
    if (checkRes.data.reason == 'self') {
      this.inforWindowDescription = this.inforWindowDescription + '<br /> To self-exclude from participating online gambling companies licensed in Great Britain go to <a href="https://www.gamstop.co.uk">https://www.gamstop.co.uk.</a>';
    }
    this.events.publish('showInfoDialog')
  }

  async ngOnInit() {
    this.platform.ready().then(() => {
      this.realityCheckService.start();
      this.pushServ.initializePush();
    });
    SplashScreen.hide().catch((err) => console.error(err));
    // If using a custom driver:
    // await this.storage.defineDriver(MyCustomDriver)
    const userSessionToken = this.authTokenStore.getToken();

      this.cCheck.checkCountry().subscribe({
        next: (countryCheckRes) => {
          this.cCheck.checkAppVersion().subscribe(appcheck => {
            if (userSessionToken == null || userSessionToken === '') {
              this.router.navigate(['']);
              // this.router.navigate(['registration']);
              this.pushServ.requestPermission();
            } else {
              this.appsFlyerServ.sendAppsFlyerUIDToServer(userSessionToken);
              this.checkLoginExlusion(userSessionToken);
              this.pushServ.resumeWebPush();
            }
          })
        },
        error: (error) => {
          this.router.navigate(['']);
          console.log('checkCountry error', error);
        }
      });
  }

  //@ts-ignore
  async checkLoginExlusion (userSessionToken) {
    if(!userSessionToken) return false;
    this.excl.checkExclusion(userSessionToken, 'login').then((notExcluded: any) => {
      // notExcluded.result = false;
      // notExcluded.data = {
      //   apiCode: 'sdfsd',
      //   length: 12,
      //   since: {date: '123-34233 '},
      //   reason: 'self'
      // };
      // console.log('notExcluded', notExcluded);
      if(notExcluded.result){
        this.api.userDetails(userSessionToken).subscribe(userDetail => {
          const user = userDetail.data.user;
          // this.firebaseStats.setUserId(user.id);
        });

        // this.router.navigate(['/tabs/home']);
        // this.app.getRootNav().setRoot('LiveCardF1Page', {gameId: 123});
        //
        // this.rootPage = Tab5Root;
      } else if (notExcluded.data.apiCode === 'EXCLUDED') {
        this.inforWindowDescription = 'Your account has been restricted for ' + notExcluded.data.length + ' from ' + notExcluded.data.since + '. Please contact ' + ENV.supportEmail + ' for more information.';
        if (notExcluded.data.reason === 'self') {
          this.inforWindowDescription = this.inforWindowDescription + '<br /> To self-exclude from participating online gambling companies licensed in Great Britain go to <a href="https://www.gamstop.co.uk">https://www.gamstop.co.uk.</a>';
        }
        this.events.publish('showInfoDialog');
      } else if(notExcluded.data.apiCode === 'GAMSTOP') {
        this.inforWindowDescription = 'Your account has been restricted. Please contact <a href="mailto:'+ENV.supportEmail+'">' + ENV.supportEmail + '</a> for more information.'
        this.events.publish('showInfoDialog');
      } else {
        this.presentToast('There was a problem logging you in. Please try again or click the link below to get a password reminder', 10000);
      }
    }).catch((error) => {
      this.tokenService.clearAllExcept();
      // this.storage.remove('userSessionToken');
      this.router.navigate(['welcome']);
      this.pusherServ.deInitChannels();
    });
  }

  needShow() {
    console.log('showInfoComponent');
    this.showInfoComponent = true;
  }

  clearUserSession() {
    this.tokenService.clearAllExcept();
    // this.storage.remove('userSessionToken');
    // this.storage.remove('userCreatedAt');
    this.goTo('welcome');
  }

  goTo(page: string) {
    this.router.navigate([page]);
  }

  async presentToast(msg, dur, position = 'top') {
    const toast = await this.toastController.create({
      message: msg,
      duration: dur,
      position: 'top'
    });
    toast.present();
  }
}
